<template>
  <!--todo subtitle bgcolor-->
  <SectionTemplate
    class="avatar-wrap scene-introduction-avatar-wrap"
    title="为专业视频创作打造的高品质场景库"
    subTitle="开箱即用的专业场景库"
    desc="无论是影视级的画质表现、灵活可编辑的场景元素，还是智能生动的AI运镜与专业的企业级定制，
魔珐有言的AI视频场景库，以海量资源与顶尖画质，成为内容创作者与企业的效率利器。"
  >
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '~/utils/url';
const featureList = [
  {
    title: `影视级超写实画质
打造极致沉浸感`,
    description:
      '基于强大的3D场景构建能力，我们提供拥有逼真光影与细节的超写实背景。相较于普通2D背景，它能带来无与伦比的空间感与沉浸感，让观众身临其境，极大提升内容的表现力与专业档次，成为您的品质保障。',
    alt: '影视级超写实画质',
    image: getFeUrl('/youyan-platform/scene/profession/1.jpg?x-oss-process=image/format,webp'),
  },
  {
    title: `2D/3D/透明背景全覆盖
满足全链路创作需求`,
    description:
      '涵盖从营造空间感的3D场景、快速出片的2D背景，到可自由合成的透明背景，为视频创作提供全面灵活的视觉解决方案，无缝支持从内容快速迭代到深度定制的各类工作流。',
    image: getFeUrl('/youyan-platform/scene/profession/2.jpg?x-oss-process=image/format,webp'),
    reverse: true,
    alt: '2D/3D/透明背景',
  },
  {
    title: `结合AI运镜技术
自动生成舞台级镜头语言`,
    description:
      '内置AI导演，结合独有的AI运镜技术为视频设计多角度、富有节奏感的专业运镜。告别单调的固定机位和固定背景，通过舞台般的镜头节奏感与视觉冲击力，有效提升视频的完播率与互动数据。',
    image: getFeUrl('/youyan-platform/scene/profession/3.jpg?x-oss-process=image/format,webp'),
    alt: 'AI运镜技术',
  },
];
</script>

<style lang="scss" scoped>
.avatar-wrap {
  background: var(--x-back-3);
  &:deep(.sub-title) {
    background-color: var(--x-back-5);
  }
}
.card-list {
  @apply flex-col items-center gap-[240px] w-full;
}
</style>
<style>
.scene-introduction-avatar-wrap {
  .sub-title {
    background-color: var(--x-back-5) !important;
  }
}
</style>
